(()=>{
  const context=document.querySelector('[data-imperial-discovery-context]');
  if(!context)return;
  const ctx=context.dataset.imperialDiscoveryContext||'';
  const handle=ctx.startsWith('collection-')?ctx.slice(11):'';
  const jewelleryHandles=new Set(['all-jewellery','rings','chains','necklaces','charms-pendants','bracelets','bangles','earrings','cufflinks','jewellery-accessories','wedding-bands','mens-rings','mens-chains','mens-necklaces','mens-bracelets','mens-earrings','womens-rings','womens-necklaces','womens-bracelets','womens-earrings','unisex-bracelets','mens-jewellery','womens-jewellery','unisex-jewellery']);
  if(!jewelleryHandles.has(handle))return;

  const norm=s=>(s||'').replace(/\s+/g,' ').trim().toLowerCase();
  const recipientIcon='<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="8" cy="8" r="3"/><circle cx="16.5" cy="9" r="2.5"/><path d="M2.8 20c.4-4 2.3-6 5.2-6s4.8 2 5.2 6M13.5 15.2c.8-.8 1.8-1.2 3-1.2 2.5 0 4 1.7 4.5 5"/></svg>';

  function recipientNav(){
    return [...document.querySelectorAll('.imperial-discovery-refine__pills')].find(el=>norm(el.getAttribute('aria-label')).includes('recipient'))||null;
  }

  function simplifyRecipientTop(){
    const nav=recipientNav();
    if(!nav)return;
    [...nav.querySelectorAll('a')].forEach(a=>{if(/^all\b/i.test((a.textContent||'').trim()))a.remove();});
  }

  function ensureAllJewelleryUnisex(){
    if(handle!=='all-jewellery')return;
    const blocks=[...document.querySelectorAll('.imperial-fallback-facet')];
    const recipient=blocks.find(block=>norm(block.querySelector('summary')?.textContent).includes('recipient'));
    const options=recipient?.querySelector('.imperial-fallback-facet__options');
    if(!options||[...options.querySelectorAll('a')].some(a=>norm(a.textContent)==='unisex'))return;
    const a=document.createElement('a');
    a.href='/collections/unisex-jewellery';
    a.className='imperial-fallback-facet__option';
    a.innerHTML=`<span class="imperial-option-icon" aria-hidden="true">${recipientIcon}</span><span>Unisex</span>`;
    options.appendChild(a);
  }

  function ensureRecipientFallback(){
    const wrapper=document.querySelector('#main-collection-filters #FacetsWrapperDesktop');
    if(!wrapper)return;
    if(wrapper.querySelector('details[data-imperial-facet-kind="recipient"],.imperial-recipient-fallback'))return;
    const nav=recipientNav();
    if(!nav)return;
    const routes=[...nav.querySelectorAll('a[href]')]
      .map(a=>({href:a.href,label:(a.textContent||'').trim(),current:a.getAttribute('aria-current')==='page'}))
      .filter(item=>item.label&&!/^all\b/i.test(item.label));
    if(!routes.length)return;
    const details=document.createElement('details');
    details.open=true;
    details.className='imperial-fallback-facet imperial-recipient-fallback';
    details.dataset.imperialFacetKind='recipient';
    const summary=document.createElement('summary');
    summary.innerHTML=`<span class="imperial-facet-icon imperial-facet-icon--v3" data-imperial-kind="recipient" aria-hidden="true">${recipientIcon}</span><span>Recipient</span>`;
    const options=document.createElement('div');
    options.className='imperial-fallback-facet__options';
    routes.forEach(route=>{
      const a=document.createElement('a');
      a.href=route.href;
      a.className='imperial-fallback-facet__option'+(route.current?' is-current':'');
      a.innerHTML=`<span class="imperial-option-icon" aria-hidden="true">${recipientIcon}</span><span>${route.label.replace(/</g,'&lt;').replace(/>/g,'&gt;')}</span>`;
      options.appendChild(a);
    });
    details.append(summary,options);
    wrapper.prepend(details);
  }

  function addSterlingToPriceFields(){
    document.querySelectorAll('#main-collection-filters details[data-imperial-facet-kind="price"] .field__label,.mobile-facets__details[data-imperial-facet-kind="price"] .field__label').forEach(label=>{
      const t=(label.textContent||'').trim();
      if(t&&!t.includes('£'))label.textContent=`${t} (£)`;
    });
  }

  function markAndSortSoldOut(){
    const grid=document.querySelector('#product-grid');
    if(!grid)return;
    const cards=[...grid.children].filter(el=>el.classList&&el.classList.contains('grid__item'));
    if(cards.length<2)return;
    cards.forEach(card=>{
      const state=card.dataset.imperialSellability||'';
      const text=norm(card.textContent);
      const sold=state==='unavailable'||text.includes('sold out')||text.includes('unavailable');
      card.dataset.imperialSoldOut=sold?'true':'false';
    });
    const sorted=[...cards].sort((a,b)=>Number(a.dataset.imperialSoldOut==='true')-Number(b.dataset.imperialSoldOut==='true'));
    const changed=sorted.some((card,index)=>card!==cards[index]);
    if(changed)sorted.forEach(card=>grid.appendChild(card));
  }

  function run(){
    simplifyRecipientTop();
    ensureAllJewelleryUnisex();
    ensureRecipientFallback();
    addSterlingToPriceFields();
    markAndSortSoldOut();
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});
  else run();
  let timer;
  new MutationObserver(()=>{
    clearTimeout(timer);
    timer=setTimeout(run,120);
  }).observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',run);
})();
